const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Footer() {
  return (
    <footer
      className="border-t border-white/10 bg-[#050505]"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="font-serif-lux text-3xl tracking-[0.15em]">LUCAS</p>
          <p className="text-[10px] tracking-[0.4em] uppercase text-[#d4af37] mt-2">
            Private Transfers
          </p>
          <p className="mt-8 max-w-sm text-base leading-relaxed tracking-wide text-[#888]">
            Blue Mountains tours & transfers — private transfers, bespoke
            tours, weddings, airport runs and group travel across the
            Mountains and Greater Sydney.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#888] mb-6">
            Explore
          </p>
          <div className="flex flex-col gap-4 text-sm text-[#aaa]">
            <button data-testid="footer-services-link" onClick={() => scrollTo("services")} className="text-left hover:text-[#d4af37] transition-colors duration-300">Services</button>
            <button data-testid="footer-fleet-link" onClick={() => scrollTo("fleet")} className="text-left hover:text-[#d4af37] transition-colors duration-300">Vehicle & Driver</button>
            <button data-testid="footer-manifesto-link" onClick={() => scrollTo("manifesto")} className="text-left hover:text-[#d4af37] transition-colors duration-300">Manifesto</button>
            <button data-testid="footer-reserve-link" onClick={() => scrollTo("booking")} className="text-left hover:text-[#d4af37] transition-colors duration-300">Book</button>
          </div>
        </div>
        <div className="md:col-span-4">
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#888] mb-6">
            Contact
          </p>
          <div className="flex flex-col gap-4 text-sm text-[#aaa]">
            <a href="tel:+61452512770" data-testid="footer-phone" className="hover:text-[#d4af37] transition-colors duration-300">0452 512 770</a>
            <a href="mailto:lucasprivatetransfers@gmail.com" data-testid="footer-email" className="hover:text-[#d4af37] transition-colors duration-300">lucasprivatetransfers@gmail.com</a>
            <span>Blue Mountains NSW, Australia</span>
            <span>Bookings available 7 days</span>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8 flex flex-wrap items-center justify-between gap-4 text-[10px] tracking-[0.25em] uppercase text-[#555]">
          <span>© 2026 LucasPrivateTransfers</span>
          <span>Blue Mountains · Greater Sydney</span>
        </div>
      </div>
    </footer>
  );
}
